"use client";

export interface VehicleRatesAndAvailabilityProps {
  weekdayRate: number;
  weekendRate: number;
  minStay: number;
  maxStay: number;
}

export function VehicleRatesAndAvailability({
  weekdayRate,
  weekendRate,
  minStay,
  maxStay,
}: VehicleRatesAndAvailabilityProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };

  return (
    <div className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">Rates & Availability</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        {/* Weekday Rate */}
        <div className="bg-muted p-4 rounded-sm bg-[#F3F4F6]">
          <p className="text-muted-foreground text-sm mb-1">Weekday Rate</p>
          <p className="text-3xl font-bold mb-1">
            {formatCurrency(weekdayRate)}
          </p>
          <p className="text-sm text-muted-foreground">per night (Sun-Thu)</p>
        </div>

        {/* Weekend Rate */}
        <div className="bg-muted p-4 rounded-sm bg-[#F3F4F6]">
          <p className="text-muted-foreground text-sm mb-1">Weekend Rate</p>
          <p className="text-3xl font-bold mb-1">
            {formatCurrency(weekendRate)}
          </p>
          <p className="text-sm text-muted-foreground">per night (Fri-Sat)</p>
        </div>
      </div>

      <div className="border-y border-[#E2E8F0] py-8 space-y-1">
        <p className="text-sm text-[#64748B]">
          Minimum stay: {minStay} night(s)
        </p>
        <p className="text-sm text-[#64748B]">
          Maximum stay: {maxStay} night(s)
        </p>
      </div>
    </div>
  );
}
